import React from 'react';

const IDCardDownloadSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4286 9.05882H20L12 17.2941L4 9.05882H8.57143V2H15.4286V9.05882ZM4 22V19.6471H20V22H4Z"
      className="IDCard-SVG"
    />
  </svg>
);

const EmailSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="Account-SVG-alg"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7 5H19.3C20.235 5 21 5.765 21 6.7V16.9C21 17.835 20.235 18.6 19.3 18.6H5.7C4.765 18.6 4 17.835 4 16.9L4.0085 6.7C4.0085 5.765 4.765 5 5.7 5ZM12.5 12.65L19.3 8.4V6.7L12.5 10.95L5.7 6.7V8.4L12.5 12.65Z"
      className="IDCard-SVG"
    />
  </svg>
);

export { IDCardDownloadSVG, EmailSVG };
